import { BulkRateValidation } from 'uplisting-frontend/validations/bulk-rate';

export const BulkMlosValidation = BulkRateValidation;
